import { useIntl, useSetPageTitle } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { ApprovedFooter } from '@capsicum/features/regulations/web';
import { SellEntrypoint, usePartnerGuarded } from '@capsicum/socios-core';
import { useParams } from 'next/navigation';

import {
	BonusAndOnHoldSummarySection,
	BuySellButtonsSection,
	InUseSection,
	OnHoldSection,
	PartnerBalanceSection,
	TokenSummarySection,
	TransactionHistorySection
} from './sections';
import { WalletCollectiblesSection } from './sections/WalletCollectiblesSection';
import { PageSkeleton } from './WalletPartnerDetails.skeletons';
import { PageWrapper, SectionWrapper, WalletDetailsHeaderWarning } from './WalletPartnerDetails.styled';

export const WalletPartnerDetails = () => {
	const { $t } = useIntl();
	const params = useParams();
	const router = useRouter();
	const ledgerId = params.ledgerId as string;
	const { isLoading, partner } = usePartnerGuarded('currencyId', params['currencyId'] as string, () =>
		router.replace('/')
	);

	const partnerId = partner?.id;
	const currencyId = partner?.currencyId;
	const partnerCode = partner?.shortName;
	const partnerLogo = partner?.images?.partnerLogo?.url;

	useSetPageTitle(partner ? $t('wallet.partnerDetails.pageTitle', { partner: partner?.shortName }) : '');

	if (isLoading) {
		return <PageSkeleton />;
	}

	if (!partnerId || !currencyId || !ledgerId || !partnerCode) return <PageWrapper />;

	return (
		<PageWrapper>
			<WalletDetailsHeaderWarning page="fanTokenWallet" verticalPadding />
			<SectionWrapper>
				<PartnerBalanceSection currencyId={currencyId} partnerId={partnerId} />
				<BuySellButtonsSection
					entrypoint={SellEntrypoint.WalletPartner}
					fanTokenCurrencyId={currencyId}
					partnerId={partnerId}
				/>
				<TokenSummarySection ledgerId={ledgerId} shortCode={partnerCode} />
				<BonusAndOnHoldSummarySection ledgerId={ledgerId} shortCode={partnerCode} />
			</SectionWrapper>
			<InUseSection ledgerId={ledgerId} shortCode={partnerCode} />
			<OnHoldSection ledgerId={ledgerId} partnerCode={partnerCode} />
			<WalletCollectiblesSection partnerId={partnerId} />
			<TransactionHistorySection currencyId={currencyId} partnerLogo={partnerLogo} />
			<ApprovedFooter page="fanTokenWallet" />
		</PageWrapper>
	);
};
